import {BaseDto} from '../../../../common/src/lib/dtos/base.dto';


export class ReathletikGiveAccessRequestDto extends BaseDto {
    userCode: string;
    protocols: string[];

    public deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }

    constructor(userCode: string, protocols: string[]) {
        super();
        this.userCode = userCode;
        this.protocols = protocols;
    }
}


